import TagManager from 'react-gtm-module';

export const initializeTagManager = (gtmId: string): void => {
  TagManager.initialize({ gtmId });
  window.TagManager = TagManager;
};
